import { render, staticRenderFns } from "./improve-service.vue?vue&type=template&id=10fbf34c&"
import script from "./improve-service.vue?vue&type=script&lang=js&"
export * from "./improve-service.vue?vue&type=script&lang=js&"
import style0 from "./improve-service.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports